import { requestV2 } from "@/config/serve.js";

const UPDATE_BLACKLIST_ENDPOINTS = {
  list: "/marketUpdate/blacklist/list",
  save: "/marketUpdate/blacklist/save",
  update: "/marketUpdate/blacklist/update",
  delete: "/marketUpdate/blacklist/delete",
};

export function getList(params) {
  return requestV2("post", UPDATE_BLACKLIST_ENDPOINTS.list, params);
}

export function addRecord(params) {
  return requestV2("post", UPDATE_BLACKLIST_ENDPOINTS.save, params);
}

export function editRecord(params) {
  return requestV2("post", UPDATE_BLACKLIST_ENDPOINTS.update, params);
}

export function deleteRecord(params) {
  return requestV2("post", UPDATE_BLACKLIST_ENDPOINTS.delete, params);
}
